var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "classroomArrangementItem", on: { click: _vm.clickItem } },
    [
      _c("div", { staticClass: "bgtype", class: _vm.bgimg }, [
        _c("span", { staticClass: "type" }, [
          _vm._v(_vm._s(_vm.item.typeText)),
        ]),
      ]),
      _c("div", { staticClass: "item-content" }, [
        _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.item.name))]),
        _c("div", { staticClass: "line" }),
        _c("div", { staticClass: "content" }, [
          _vm.item.className
            ? _c("div", { staticClass: "detail" }, [
                _c("img", {
                  attrs: {
                    src: require("_teas/public/img/product/bootScreen/icon-hd.png"),
                    alt: "",
                    srcset: "",
                  },
                }),
                _c("div", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.item.className)),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "detail" }, [
            _c("img", {
              attrs: {
                src: require("_teas/public/img/product/bootScreen/icon-teacher.png"),
                alt: "",
                srcset: "",
              },
            }),
            _c("div", { staticClass: "text" }, [
              _vm._v(_vm._s(_vm.item.speakerText)),
            ]),
          ]),
          _c("div", { staticClass: "detail" }, [
            _c("img", {
              attrs: {
                src: require("_teas/public/img/product/bootScreen/icon-time.png"),
                alt: "",
                srcset: "",
              },
            }),
            _c("div", { staticClass: "text" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.item.affairDate) +
                  " " +
                  _vm._s(_vm.item.beginTime) +
                  "-" +
                  _vm._s(_vm.item.endTime) +
                  " "
              ),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }